import { AxiosService } from './axiosService';

export class ServiceTypesService extends AxiosService {
    async getServiceTypes() {
        try {
            const { data } = await this.axios.get("/service-types");
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postServiceType(name) {
        try {
            const { data } = await this.axios.post("/service-types", {
                name
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const serviceTypeService = new ServiceTypesService();